<template>
  <div id="user-list">
    <!-- list filters -->
    <v-card>
      <v-card-text>
        <CRUDTable
          ref="theTable"
          :external-loading="loading"
          :remote-create-item="remoteCreateItem"
          :remote-update-item="remoteUpdateItem"
          :remote-delete-item="remoteDeleteItem"
          :remote-get-item="remoteGetItem"
          :fetch-list="fetchList"
          edit-with="1000px"
          :search-key-word="searchKeyWord"
          :form-config="formConfig"
          :input-configs="inputConfigs"
          :create-params-callback="createParamsCallback"
          :extra-input-call-back="extraInputCallBack"
          @reset="handleReset"
          @openEditDialog="openEditDialog"
          @setupExtraInput="listenExtraInput"

          @openDeleteDialog="openDeleteDialog"
        >
          <template v-slot:extra-top>
            <v-container>
              <v-card>
                <v-card-title>
                  Role
                </v-card-title>
                <v-card-text>
                  <v-row>
                    <v-col
                      v-for="item in sysRoleList"
                      :key="item.id"
                      class="pa-2"
                    >
                      <!-- input-value="true" -->
                      <v-checkbox
                        v-model="checkboxSysRoleList"
                        :disabled="deleteDialog"
                        :label="item.name"
                        :value="item.id"
                        @change="eventCheckbox"
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>

              <v-card v-if="enableCenterSearch">
                <v-card-title>
                  Center(Just for Reception)
                </v-card-title>
                <v-card-text>
                  <v-row>
                    <v-col
                      v-for="item in centerList"
                      :key="item.id"
                      class="pa-2"
                    >
                      <!-- input-value="true" -->
                      <v-checkbox
                        v-model="checkboxCenterList"
                        :disabled="deleteDialog"
                        :label="item.code"
                        :value="item.id"
                        @change="eventCenterCheckbox"
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-container>
          </template>
          <template v-slot:extraInput>
            <!-- <v-container>
              <v-card>
                <v-card-title>
                 Role
                </v-card-title>
                <v-card-text>
                  <v-row>
                    <v-col
                      v-for="item in sysRoleList"
                      :key="item.id"
                      class="pa-2"
                    >

                      <v-checkbox
                        v-model="selectedsysRoleList"
                        :disabled="deleteDialog"
                        :label="item.name"
                        :value="item.id"
                        @change="eventEditCheckbox"
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                </v-card-text>
                </v-card>
            </v-container> -->

            <v-container>
              <v-card>
                <v-card-title>
                  Role
                </v-card-title>
                <v-card-text>
                  <v-radio-group
                    v-model="radios"
                    :disabled="deleteDialog"
                    :rules="raidoRule"
                    row
                  >
                    <v-row>
                      <v-col
                        v-for="item in sysRoleList"
                        :key="item.id"
                        class="pa-2"
                      >
                        <v-radio
                          :disabled="deleteDialog"
                          :label="item.name"
                          :value="item.id"
                        ></v-radio>
                      </v-col>
                    </v-row>
                  </v-radio-group>
                </v-card-text>
              </v-card>

              <v-card v-if="enableEditCenterSearch">
                <v-card-title>
                  Center
                </v-card-title>
                <v-card-text>
                  <v-row>
                    <v-col
                      v-for="item in centerList"
                      :key="item.id"
                      class="pa-2"
                    >
                      <!-- input-value="true" -->
                      <v-checkbox
                        v-model="selectedCenterList"
                        :label="item.code"
                        :value="item.id"
                        :disabled="deleteDialog"
                        :rules="selectedCoachCenterListRule"
                        required
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-container>
          </template>
        </CRUDTable>
      </v-card-text>
    </v-card>
  </div>
</template>

<script setup>
import sha512 from 'crypto-js/sha512'
import {
  mdiAccountOutline,
  mdiDeleteOutline,
  mdiDotsVertical,
  mdiExportVariant,
  mdiFileDocumentOutline,
  mdiPlus,
  mdiSquareEditOutline,
} from '@mdi/js'
import { ref, onMounted, watch } from 'vue'
import moment from '@/utils/moment'
import {
  createItem as remoteCreateItem, deleteItem as remoteDeleteItem,

  fetchList, updateItem as remoteUpdateItem, getItem as remoteGetItem,
} from '@/api/userProfiles'

import UniversalInput from '@/components/CRUD/UniversalInput'
import InputContainer from '@/components/CRUD/InputContainer'

import CRUDTable from '@/components/CRUD/CRUDTable'
import { useStore } from '@/store'

const theTable = ref(null)
function handleReset() {
  console.log('handleReset')
}
function onEditDialog(action) {
  console.log('action', action)
}
const store = useStore()
const loading = ref(false)
const searchKeyWord = ref('')

const centerList = ref([])
const selectedCenterList = ref([])

const courseList = ref([])
const selectedCourseList = ref([])

const editDialog = ref(false)
const editIndex = ref(-1)
const hintSentence = ref('')

const editSysRole = ref(0)

const sysRole = ref(null)

const sysRoleList = ref([])

const enableCenterSearch = ref(true)
const enableEditCenterSearch = ref(false)

const checkboxSysRoleList = ref([])
const checkboxCenterList = ref([])

const findReceptionID = ref(0)

const selectedsysRoleList = ref([])

const userSysRoleList = ref([])

const radios = ref(0)

const selectedCoachCenterList = ref([])
const selectedCoachCourseList = ref([])

const deleteDialog = ref(false)

const editBasicSalary = ref(null)
const editPosition = ref('')

const selectedCoachCenterListRule = [
  // v =>  {console.log('basicSalary', typeof v)   },
  v => {
    if ((radios.value == findReceptionID.value)) {
      if (selectedCenterList.value.length == 0) {
        return 'Please select one of them'
      }

      return null
    }
  },

]

const raidoRule = [
  // v =>  {console.log('basicSalary', typeof v)   },
  v => {
    if ((radios.value == 0)) { return 'Please select one of them' }
  },

]

// const extraInput = ref([{

//   value: selectedCenterList,
//   propName: 'selectedCenterList',
//   label: 'CenterList',

//   Rules: [
//      // v =>  {console.log('basicSalary', typeof v)   },
//     v => {
//       if ((radios.value == findReceptionID.value)) {

//         if (selectedCenterList.value.length == 0) {
//           return 'Please select center for reception'
//         }else{
//           return 'Please select center for reception'
//         }
//       }
//     },

//   ],

// },

// ])

onMounted(() => {
  store.dispatch('center/list', {})
    .then(result => {
      console.log('center result', result)
      centerList.value = result.items
      for (let index = 0; index < centerList.value.length; index += 1) {
        const value = centerList.value[index].id
        checkboxCenterList.value.push(value)
        console.log('selectedCenterList.value', checkboxCenterList.value)
      }
    })

  store.dispatch('sysRole/userprofileList')
    .then(result => {
      console.log('userprofileList result', result)
      sysRoleList.value = result.items
      for (let index = 0; index < sysRoleList.value.length; index += 1) {
        const value = sysRoleList.value[index].id
        if (sysRoleList.value[index].name.toLowerCase() == 'reception') {
          findReceptionID.value = sysRoleList.value[index].id
        }

        checkboxSysRoleList.value.push(value)

        console.log('checkboxSysRoleList.value', checkboxSysRoleList.value)
      }

      theTable.value.fetchData()

      //   store.dispatch('course/list', {})
      // .then( courseReponse => {
      //   courseList.value = courseReponse.items

      //   for (let index = 0; index < courseList.value.length; index += 1) {
      //     // selectedCenterList.value = [...centerList.value.code]
      //     const value = courseList.value[index].id
      //     selectedCourseList.value.push(value)

      //     console.log('selectedCourseList.value', selectedCourseList.value)
      //   }

      //   theTable.value.fetchData()
      // }).catch(err => {
      //   console.log('err', err)

      // })
    })
    .catch(err => {
      console.log('err', err)
    })
})

watch([checkboxSysRoleList], (newValue, oldValue) => {
  console.log('ddddd', checkboxSysRoleList.value.includes(findReceptionID.value))
  if (checkboxSysRoleList.value.includes(findReceptionID.value)) {
    console.log('enableCenterSearch = true')
    enableCenterSearch.value = true
  } else {
    console.log('enableCenterSearch = false')
    enableCenterSearch.value = false

  // console.log("myArray does not contain 3");
  }
})

watch([radios], (newValue, oldValue) => {
  if (newValue == findReceptionID.value) {
    enableEditCenterSearch.value = true
  } else {
    enableEditCenterSearch.value = false
  }
})

function createParamsCallback(params) {
  // params.centerList = selectedCenterList.value
  // params.courseList = selectedCourseList.value
  params.sysRoleList = checkboxSysRoleList.value

  params.centerList = checkboxCenterList.value

  // console.log('params.centerList', params.centerList)

  return params
}

function eventCheckbox(e) {
  // console.log('eventCheckbox', e)

  checkboxSysRoleList.value = [...e]
  theTable.value.fetchData()
}

function eventCenterCheckbox(e) {
  // console.log('eventCheckbox', e)

  checkboxCenterList.value = [...e]
  theTable.value.fetchData()
}

function eventEditCheckbox(e) {
  // console.log('eventCheckbox', e)
  selectedsysRoleList.value = [...e]
}

function eventCourseCheckbox(e) {
  // console.log('eventCheckbox', e)
  selectedCourseList.value = [...e]
  console.log('eventCourseCheckbox', selectedCourseList.value)
  theTable.value.fetchData()
}

function eventCheckSysRoleEditbox(e) {
  console.log('eventCheckSysRoleEditbox', e)

  // selectedRoleList.value = [...e]
}

function listenExtraInput(e) {
  // edit mode
  console.log('listenExtraInput(e)', e)

  radios.value = 0
  selectedCoachCenterList.value = []

  userSysRoleList.value = e.sysUserRoles

  const duplicatedRecords = sysRoleList.value.filter(item1 => userSysRoleList.value.some(item2 => item2.sysRoleID === item1.id))

  // console.log('duplicatedRecords', duplicatedRecords)
  if (duplicatedRecords) { radios.value = duplicatedRecords[0].id }

  // const temp = []
  // for (let index = 0; index < e.coachCenter.length; index += 1) {
  //   temp.push(e.coachCenter[index].centerID)
  // }
  // selectedCoachCenterList.value = [...temp]

  // const CoachCoursetemp = []
  // for (let index = 0; index < e.coachCourse.length; index += 1) {
  //   CoachCoursetemp.push(e.coachCourse[index].courseID)
  // }
  // selectedCoachCourseList.value = [...CoachCoursetemp]

  const sysRoleTemp = []
  for (let index = 0; index < e.sysUserRoles.length; index += 1) {
    sysRoleTemp.push(e.sysUserRoles[index].sysRoleID)
  }
  selectedsysRoleList.value = [...sysRoleTemp]

  console.log('edit mode', selectedCenterList.value)
  const centerTemp = []
  for (let index = 0; index < e.coachCenter.length; index += 1) {
    centerTemp.push(e.coachCenter[index].centerID)
  }
  selectedCenterList.value = [...centerTemp]

  // console.log('sysRoleTemp',sysRoleTemp[0])
  radios.value = sysRoleTemp[0]

  // console.log('editBasicSalary.value' , editBasicSalary.value)

  // console.log('editPosition.value' , editPosition.value)
}

function openEditDialog(e) {
  console.log('openEditDialog', e)
  editIndex.value = e

  // console.log('theTable.value.getEditedItem()', theTable.value.getEditedItem())

  if (e > -1) {
    editDialog.value = false
    inputConfigs.value[3].label = 'Password'
    inputConfigs.value[4].label = 'Confirm Password'
  } else {
    editDialog.value = true

    inputConfigs.value[3].label = 'Reset Password'
    inputConfigs.value[4].label = 'Confirm Reset Password'
  }
}

function extraInputCallBack(e) {
  // e.SysRoleIDList = selectedsysRoleList.value

  e.SysRoleID = radios.value

  if (radios.value == findReceptionID.value) { e.CenterList = selectedCenterList.value }

  if (e.confirmedPassword == e.password && (e.password != '' && e.confirmedPassword != '')
  && (e.password !== undefined && e.confirmedPassword !== undefined)) {
    e.confirmedPasswordSha = sha512(e.confirmedPassword.trim()).toString()
  }

  console.log('extraInputCallBack', e)

  // radios.value = 0
  // selectedCenterList.value = []

  return e
}

function openDeleteDialog(e) {
  console.log('openDeleteDialog', e)

  if (e === false) {
    deleteDialog.value = e
    editDialog.value = false
    radios.value = 0
    selectedsysRoleList.value = []
    userSysRoleList.value = []
  } else {
    deleteDialog.value = true
    radios.value = e.sysUserRoles[0].sysRoleID
  }
}

const sysRoleConfig = ref([{
  propName: 'sysRoleID',
  label: 'Role',
  required: true,
  type: {
    name: 'checkboxGroup',
    isHorizontal: true,
    groupItems: [
      { propName: 'COACH_FT', itemValue: 2, itemName: 'sysRoleID', label: 'COACH(FT)' },
      { propName: 'COACH_FL', itemValue: 3, itemName: 'sysRoleID', label: 'COACH(FL)' },
    ],
  },
}])

const formConfig = {
  delete: { title: 'Terminate' },
  title: 'UserProfiles',
  searchLabel: 'Search for name',
  headers: [
    { value: 'id', text: 'Id' },
    { value: 'sysRole', text: 'Role', sortable: false },
    { value: 'userNo', text: 'UserNo' },
    { value: 'firstName', text: 'FirstName' },
    { value: 'lastName', text: 'LastName' },

    // { value: 'nickName', text: 'NickName' },
    // { value: 'mobileNo', text: 'MobileNo' },
    // { value: 'email', text: 'Email' },
    // { value: 'gender', text: 'Gender' },
    // { value: 'hkid', text: 'HKID' },

    { value: 'actions', text: 'Actions', sortable: false },
  ],

  customColumns: [
    {

      name: 'sysRole',
      callback(sysRole, record) {
        let role = ''
        for (let index = 0; index < record.sysUserRoles.length; index += 1) {
          role += `${record.sysUserRoles[index].sysRole.name},`
        }
        role = role.slice(0, -1)

        return role
      },
    }],
}

const icons = ref({
  mdiSquareEditOutline,
  mdiFileDocumentOutline,
  mdiDotsVertical,
  mdiDeleteOutline,
  mdiPlus,
  mdiExportVariant,
  mdiAccountOutline,
})
const inputConfigs = ref([
  {
    propName: 'firstName',
    label: 'First Name',
    type: {
      rules: [
        v => (typeof v === 'string' && v.length > 0) || 'First Name is required',
      ],
    },

  },
  {
    propName: 'lastName',
    label: 'Last Name',
    type: {
      rules: [
        v => (typeof v === 'string' && v.length > 0) || 'Last Name is required',
      ],
    },
  },
  {
    propName: 'nickName',
    label: 'NickName',
    type: {
      rules: [
        v => (typeof v === 'string' && v.length > 0) || 'Nick Name is required',
      ],
    },
  },

  {
    hint: (editDialog.value ? 'if you are in edit mode, you can no input any password in this textbox that you dont change password' : ''),
    propName: 'password',
    label: 'Password',
    type: {
      inputType: 'password',
      rules: [
        // e.g. a123456(7)
        v => {
          if (editDialog.value) {
            if (v === undefined) { return null }

            if ((v.length == 0 && typeof v === 'string')) { return null }

            if (!(v.length >= 8 && typeof v === 'string')) {
              return 'password is required or length is more than 8'
            }
          } else {
            console.log('editDialog.value2222', editDialog.value)
            if (!(typeof v === 'string' && v.length >= 8)) {
              return 'password is required or length is more than 8'
            }
          }
        },
      ],
    },
  },
  {
    propName: 'confirmedPassword',
    label: 'Password',
    type: {
      inputType: 'password',
      rules: [

        // e.g. a123456(7)
        v => {
          if (editDialog.value) {
            if (v === undefined) { return null }

            if ((v.length == 0 && typeof v === 'string')) { return null }

            if (!(v.length >= 8 && typeof v === 'string')) {
              return 'password is required or length is more than 8'
            }

            const { confirmedPassword } = theTable.value.getEditedItem()
            const { password } = theTable.value.getEditedItem()

            if (password !== confirmedPassword && typeof v === 'string') {
              return 'not same password'
            }
          } else {
            if (!(typeof v === 'string' && v.length >= 8)) {
              return 'password is required or length is more than 8'
            }
            const { confirmedPassword } = theTable.value.getEditedItem()
            const { password } = theTable.value.getEditedItem()
            if (password !== confirmedPassword) {
              return 'not same password'
            }
          }
        },
      ],
    },
  },

  // { md: 12, propName: 'firstName ', label: 'FirstName' , },
  // { md: 12, propName: 'lastName ', label: 'LastName' },
  // { md: 12, propName: 'nickName  ', label: 'NickName ' },
  // { md: 12, propName: 'userName  ', label: 'UserAccount' },
  // { md: 12, propName: 'gender  ', label: 'Gender ' , hint: 'M or F'},

  // { md: 12, propName: 'email  ', label: 'Email '  },
  // { md: 12, propName: 'Password  ', label: 'password' },
  // { md: 12, propName: 'hKID  ', label: 'HKID ' },
  // { md: 12, propName: 'mobileNo   ', label: 'MobileNo' },

  // { md: 12, propName: 'birthday ', label: 'Birthday ' },
])
</script>

<style lang="scss">
@import '@core/preset/preset/apps/user.scss';
</style>
